import * as moment from 'moment';
import * as _ from "lodash";
import { IIndexedCase } from "src/share/types/case/caseIndexed";
import { ICase, initialCase } from "src/share/types/case/case";
import { match } from "react-router";
import { IAuthState } from "src/modules/Auth/store/types";
import { IMapCenter } from 'src/share/types/common';
export interface IAlertInsights {
  impresions: number,
  clicks: number
}
export interface IAlertInfo {
  radius: number
  stop: "Yes" | "No",
  location: string
  phone: string
  alert: string
  language: string
  expirationDate: moment.Moment,
  alertId?: string
  caseId?: string
  center?: IMapCenter
  caseInfo?: IIndexedCase | ICase;
  agencyCode: string,
  countryCode?: string;
  countryName?: string;
  state?: string;
  city?: string;
  title?: string;
  insights?: IAlertInsights
  processedDate?: number;
  processed?: boolean;
  stopReason?: string;
  childrenSelector?: IChildrenSelector;
}

export interface ICreateAlertState {
  alertInfo: IAlertInfo;
  caseInfo: ICase;
  loading: boolean;
  alertDB?: IAlertInfo;
  stopAlert: boolean;
}

export interface IChildrenSelector {
  [childId: string]: {
    selected: boolean;
    currentImage: string | undefined;
  }
}

export interface ICreateAlertProps {
  match: match<{ caseId?: string; alertId?: string }>;
  history?: any,
  auth: IAuthState;
}

export const initialStateAlert: ICreateAlertState = {
  alertInfo: {
    radius: 100,
    stop: "No",
    location: "",
    phone: "",
    alert: "",
    language: "",
    expirationDate: moment().add(2, "day"),
    agencyCode: '',
    childrenSelector: {}
  },
  stopAlert: false,
  loading: false,
  caseInfo: {
    ..._.cloneDeep(initialCase),
    children: []
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/types.ts